import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMarkCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	style: { enableBackground: "new 0 0 17 17" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.question-mark-circle-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.question-mark-circle-icon-st1{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "question-mark-circle-icon-st0",
			d: "M8.5,16c4.1,0,7.5-3.4,7.5-7.5S12.6,1,8.5,1S1,4.4,1,8.5S4.4,16,8.5,16z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "question-mark-circle-icon-st1",
			d: "M8.5,13.5c0.5,0,0.9-0.4,0.9-0.9S9,11.7,8.5,11.7s-0.9,0.4-0.9,0.9S8,13.5,8.5,13.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "question-mark-circle-icon-st0",
			d: "M8.5,9.8V9.2c0.4,0,0.9-0.1,1.2-0.4c0.4-0.2,0.6-0.6,0.8-1s0.2-0.8,0.1-1.3c-0.1-0.4-0.3-0.8-0.6-1.1 C9.7,5.1,9.3,4.9,8.9,4.8C8.5,4.7,8,4.8,7.6,4.9c-0.4,0.2-0.7,0.4-1,0.8C6.4,6.1,6.3,6.5,6.3,6.9"
		})
	] }) }) })]
});
export default SvgQuestionMarkCircleIcon;
